type BackIconProps = {
  colorFill?: string;
  width?: string;
  height?: string;
};

export const BackIcon = ({
  colorFill = '#1B478A',
  width = '60px',
  height = '60px',
}: BackIconProps) => (
  <svg fill="none" width={width} height={height} viewBox="0 0 48 48">
    <path
      d="M24 0C10.766 0 0 10.766 0 24s10.766 24 24 24 24-10.766 24-24S37.234 0 24 0Z"
      fill="#fff"
    />
    <path
      d="m17 24 12.5-12.5M17 24l12.5 12.5"
      stroke={colorFill}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
